import React, {useState, useEffect} from 'react';
import { Redirect } from 'react-router-dom';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { schemaClientInfo } from '../../../../../utils/validations';
import CircularProgress from '@material-ui/core/CircularProgress';
import FullScreenLoader from '../../../../../components/FullScreenLoader';
import InfoClient from '../../../../../components/Forms/SignUpClient/InfoClient'
import { addFormValuesClient } from '../../../../../store/modules/formValuesClient';
import { assertionStepClientSubmittedAction } from '../../../../../store/modules/assertionStepsClientSubmitted';
import { showLoading, hideLoading } from '../../../../../store/actions/LoadingActions';

const SignUpInfo = (props) => {
  const [initialValues, setInitialValues] = useState({ name:'', lastName:'', phone:''})
  const [loadingFormData, setLoadingFormData ]= useState(true)
  const [loading, setLoading]= useState(false)
  const [redirect, setRedirect]= useState(false)
  const [error, setError]= useState(null)
  const [isInitialValid, setIsInitialValid] = useState(false)
  const {
    formValuesClient,
    isFirstStepClientSubmitted,
    isSecondStepClientSubmitted,
    showLoading, 
    hideLoading,
    role
  } = props;

  useEffect(() => {
    if (isFirstStepClientSubmitted) {
      if (isSecondStepClientSubmitted) {
        setIsInitialValid(true)
        setLoadingFormData(false)
          
      } else {
        setLoadingFormData(false);
      }
    } else {
      setLoadingFormData(false)
      setRedirect(true)
    }
  },[]);

    const onSubmit = (values, { setSubmitting, setErrors, setFieldError }) => {
      if (
        props.role &&
        (props.role === 'lawFirm' ||
        props.role === 'lawyer')
      ) {
        setFieldError(
          'name',
          `Ya te encuentras autenticado como ${props.role === 'lawyer' ? 'abogado' : 'despacho'}.`
        )
      } else {
        const { submitFormValuesClient } =props;
        setLoading(true)
        //showLoading();
        setTimeout(() => {
          submitFormValuesClient(values).then(() => {
           assertionStepClientSubmitted();
           //hideLoading();
          });
        }, 1000);
      }
    }

   const assertionStepClientSubmitted = () => {

      const { submitStepClient, isClient, history } =props;
      submitStepClient({
        personalInformation: true,
      }).then(res => {
        //hideLoading();
        let url = '/usuario-registro/info-registro';
        history.push(url);
      });
    };

      if (loadingFormData) {
        return (
          <div className="flexContainer--center">
            <CircularProgress color="secondary" />
          </div>
        );
      }
  
      if (redirect) {
        return <Redirect to="/usuario-registro" />;
      }

      return ( 
        <>
         <FullScreenLoader loading={loading} />
          <Formik
            initialValues={initialValues}
            validationSchema={schemaClientInfo}
            onSubmit={onSubmit}
            render={props => <InfoClient {...props} />}
          />
        </>
      );
    }

    const mapStateToProps = state => ({
      role: state.authClient.role,
      formValuesClient: state.formValuesClient,
      isFirstStepClientSubmitted: state.stepsClientSubmitted.accountType,
      isSecondStepClientSubmitted: state.stepsClientSubmitted.personalInformation,
    });
    
    const mapDispatchToProps = dispatch => ({
      submitFormValuesClient: formValues => dispatch(addFormValuesClient(formValues)),
      submitStepClient: steps => dispatch(assertionStepClientSubmittedAction(steps)),
      showLoading: () => dispatch(showLoading()),
      hideLoading: () => dispatch(hideLoading()),
    });

export default connect(mapStateToProps, mapDispatchToProps)(SignUpInfo);